<form [formGroup]="form" class="style-form-default">
  <div
    class="style-input-default"
    data-text="Fecha de solictud *"
    [ngClass]="{ error: verificateInput('fecha_solicitud') }"
  >
    <input type="date" formControlName="fecha_solicitud" />
  </div>
  <div
    class="style-input-default"
    data-text="N° de solicitud *"
    [ngClass]="{ error: verificateInput('numero_solicitud') }"
  >
    <input
      type="text"
      onlyNumber
      placeholder="N° de solicitud"
      formControlName="numero_solicitud"
    />
  </div>
  <div
    class="style-input-default"
    data-text="Fecha de procesado *"
    [ngClass]="{ error: verificateInput('fecha_procesado') }"
  >
    <input type="date" formControlName="fecha_procesado" />
  </div>
  <div
    class="style-input-default"
    data-text="Fecha de enviado *"
    [ngClass]="{ error: verificateInput('fecha_enviado') }"
  >
    <input type="date" formControlName="fecha_enviado" />
  </div>
  <div
    class="style-input-default"
    data-text="Ente que solicita *"
    [ngClass]="{ error: verificateInput('ente_solicita') }"
  >
    <input
      type="text"
      placeholder="Ente que solicita"
      formControlName="ente_solicita"
    />
  </div>
  <div
    class="style-input-default"
    data-text="Dirección de carreo de ente que solicita *"
    [ngClass]="{ error: verificateInput('direccion_carreo') }"
  >
    <input
      type="text"
      placeholder="Dirección de correo de ente que solicita"
      formControlName="direccion_carreo"
    />
  </div>
  <div
    class="style-input-default column-complete"
    data-text="Descripción de la solicitud *"
    [ngClass]="{ error: verificateInput('descripcion_solicitud') }"
  >
    <textarea
      rows="4"
      placeholder="Descripción de la solicitud..."
      formControlName="descripcion_solicitud"
    ></textarea>
  </div>
</form>
